var map = {
	"./01.png": 1191,
	"./01web-developement-1234.png": 4138,
	"./02.png": 6294,
	"./02web-developement-1234.png": 8505,
	"./03.png": 8096,
	"./03web-developement-1234.png": 5886,
	"./04.png": 1740,
	"./04web-developement-1234.png": 1619,
	"./05.png": 3347,
	"./05web-developement-1234.png": 7261,
	"./Developing-And-Administering.png": 2433,
	"./Developing-Brand-Loyalty-Through-Email.png": 3014,
	"./Human-Touch.png": 2838,
	"./Our-Strategy.png": 5378,
	"./Pay-Per-Click-(PPC)-Advertising-on-Google-Ads.png": 3476,
	"./Smarter-Outcomes.png": 2570,
	"./We-Specialize-In-Scaling-Up.png": 8944,
	"./What-Can-We-Offer.png": 3692,
	"./What-is-the-importance-of-Email-in-your-company.png": 6933,
	"./gpdg-acting-as-a-bridge-between.png": 9685,
	"./gpdg-creating-art-that-fuels-game.png": 9304,
	"./gpdg-how-does-it-help-your-company.png": 9532,
	"./gpdg-make-our-presence-feel-throughout.png": 7963,
	"./gpdg-we-bring-it-to-life.png": 8804,
	"./keeping-simple-keeping-straight.png": 5416,
	"./uiux-distinguish-between-ui.png": 7757,
	"./uiux-the-role-of-ux-design-in.png": 4002,
	"./uiux-what-can-we-offer.png": 1422,
	"./uiux-what-is-the-importance-of.png": 801,
	"./uiux-with-best-in-class.png": 7645,
	"./webdg-garner-the-best-option.png": 8953,
	"./webdg-sustainable-growth-process.png": 1675,
	"./webdg-unleash-your-potential.png": 7786,
	"./webdg-what-would-be-our-role.png": 4969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6802;